import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/Auth";
import { BrandMark, WaFloat } from "../components/common";

function Frame({ title, children }) {
  return (
    <>
      <div className="auth-cover" style={{ gridTemplateColumns: "1fr", maxWidth: 520 }}>
        <section className="auth-card"><BrandMark big /><h2>{title}</h2>{children}</section>
      </div>
      <WaFloat />
    </>
  );
}

export function VerifyLink() {
  const nav = useNavigate();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(window.location.search).get("token") || "";
    api.post("/auth/verify-link", { token }).then(() => { setState("ok"); refreshUser(); }).catch((e) => { setState("error"); setMsg(errMsg(e)); });
  }, [refreshUser]);
  return (
    <Frame title="📧 Verificación de correo">
      {state === "loading" && <p className="muted" data-testid="verify-link-loading">Comprobando el enlace…</p>}
      {state === "ok" && <><div className="auth-flow-note" data-testid="verify-link-success">✅ Correo verificado correctamente. Tus recompensas ya están activas.</div><button className="primary" style={{ width: "100%" }} onClick={() => nav("/panel/inicio")} data-testid="verify-link-continue-btn">Entrar a mi panel</button></>}
      {state === "error" && <><div className="auth-error" data-testid="verify-link-error">{msg}</div><button className="secondary" onClick={() => nav("/")}>Volver al inicio</button></>}
    </Frame>
  );
}

export function ResetPage() {
  const nav = useNavigate();
  const [p, setP] = useState({ a: "", b: "" });
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (p.a !== p.b) return setErr("Las contraseñas no coinciden.");
    try {
      await api.post("/auth/reset", { token: new URLSearchParams(window.location.search).get("token") || "", password: p.a });
      setOk(true);
    } catch (x) { setErr(errMsg(x)); }
  };
  return (
    <Frame title="🔑 Nueva contraseña">
      {ok ? (
        <><div className="auth-flow-note" data-testid="reset-success">✅ Contraseña actualizada. Por seguridad hemos cerrado tus sesiones abiertas.</div><button className="primary" style={{ width: "100%" }} onClick={() => nav("/login")} data-testid="reset-login-btn">Iniciar sesión</button></>
      ) : (
        <form className="auth-form visible" onSubmit={submit} data-testid="reset-form">
          <div className="field"><label htmlFor="np1">Nueva contraseña</label><input id="np1" type="password" minLength={8} required value={p.a} onChange={(e) => setP({ ...p, a: e.target.value })} autoComplete="new-password" data-testid="reset-password-input" /></div>
          <div className="field"><label htmlFor="np2">Repite la contraseña</label><input id="np2" type="password" minLength={8} required value={p.b} onChange={(e) => setP({ ...p, b: e.target.value })} autoComplete="new-password" data-testid="reset-password2-input" /></div>
          <div className="auth-error" role="alert" data-testid="reset-error">{err}</div>
          <button className="primary" type="submit" data-testid="reset-submit-btn">🔄 Actualizar contraseña</button>
        </form>
      )}
    </Frame>
  );
}
